import { useEffect, useState } from "react";

/**
 * Time-of-day greeting band. Wakes every minute to catch boundary
 * crossings (e.g. the user lands on the dashboard at 10:59 and the
 * band flips to "afternoon" without a page reload).
 *
 * Bands:
 *   - 04:00–10:59 → morning
 *   - 11:00–14:59 → afternoon
 *   - 15:00–17:59 → evening
 *   - 18:00–03:59 → night
 *
 * The caller resolves the band to a localised phrase via ``t()``.
 */
export type GreetingBand = "morning" | "afternoon" | "evening" | "night";

export function useTimeGreeting(): GreetingBand {
  const [band, setBand] = useState<GreetingBand>(() => currentBand());

  useEffect(() => {
    setBand(currentBand());
    const interval = setInterval(() => {
      setBand(currentBand());
    }, 60_000);
    return () => clearInterval(interval);
  }, []);

  return band;
}

function currentBand(): GreetingBand {
  const hour = new Date().getHours();
  if (hour >= 4 && hour < 11) return "morning";
  if (hour >= 11 && hour < 15) return "afternoon";
  if (hour >= 15 && hour < 18) return "evening";
  return "night";
}
